
import { computed, defineComponent, PropType, ref, watch } from '@vue/composition-api';
import DiscoveryEmailContentType from '@/v2/discovery/DiscoveryEmailContentType.vue';
import DatePicker from '@/v2/discovery/DatePicker.vue';

export default defineComponent({
  name: 'SearchFilter',
  components: {
    DatePicker,
  },
  props: {
    total: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  emits: ['filterChange', 'changeLang', 'changeDate'],
  setup(props, { emit }) {
    const searchText = ref('');
    const selectedTab = ref('ALL');
    const language = ref<string>('all');
    const localTotal = ref(props.total);

    const tabs = [
      { key: 'ALL', label: `All (${localTotal.value})` },
      // { key: 'DAILY', label: 'General Report ' },
      // { key: 'INVESTING', label: 'Investment Report ' },
      // { key: 'COMPARISON', label: 'Comparison Report ' },
      // { key: 'INDEPTH_REVIEW', label: 'Indepth Report ' },
    ];

    const onFilterChange = () => {
      emit('filterChange', {
        keyword: searchText.value,
      });
    };

    const selectTab = (tab: any) => {
      selectedTab.value = tab.key;
      // onFilterChange();
    };

    const onChangeLang = (value: string) => {
      language.value = value;
      emit('changeLang', {
        lang: value,
      });
    };

    const languageLabel = computed(() => {
      switch (language.value) {
        case 'ko':
          return 'global.language.ko';
        case 'en':
          return 'global.language.en';
        case 'all':
        default:
          return 'global.language.all';
      }
    });

    const onChangeDate = (date: [string, string] | [null, null], type) => {
      const startDate = date[0];
      const endDate = date[1];
      emit('changeDate', {
        startDate: startDate,
        endDate: endDate,
      });
    };

    return {
      searchText,
      tabs,
      selectedTab,
      selectTab,
      onFilterChange,
      onChangeDate,
      onChangeLang,
      language,
      languageLabel,
    };
  },
});
